import React from 'react';
import { GoogleMap, useJsApiLoader, MarkerF } from '@react-google-maps/api';
import { useTranslation } from 'react-i18next';
import LoadingIndicator from '../../Loaders/LoadingIndicator';

const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string;

const containerStyle = {
    width: '100%',
    height: '400px',
    borderRadius: '8px'
};

interface PropertyMapProps {
    lat: number;
    lng: number;
}

const PropertyMap: React.FC<PropertyMapProps> = ({ lat, lng }) => {
    const { t } = useTranslation();
    const { isLoaded, loadError } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
    });

    const center = { lat, lng };

    if (loadError) {
        return <div>{t('property.map.loadError', 'Impossibile caricare la mappa.')}</div>;
    }

    if (!isLoaded) {
        return <LoadingIndicator />;
    }

    return (
        <GoogleMap
            mapContainerStyle={containerStyle}
            center={center}
            zoom={15}
            options={{
                streetViewControl: false, // Disabilita Street View per un look più pulito
                mapTypeControl: false,    // Disabilita il selettore del tipo di mappa
            }}
        >
            <MarkerF position={center} />
        </GoogleMap>
    );
};

export default React.memo(PropertyMap);